import React from 'react';
import emailjs from 'emailjs-com';
import ReCAPTCHA from "react-google-recaptcha";

export default function FormHome() {
  const succes = <div className="alert alert-success" role="alert">¡Mensaje enviado!</div>;
  const error2 = <div className="alert alert-danger" role="alert">¡Mensaje no enviado!</div>;
  const [mensajeAlert, setMensajeAlert] = React.useState("");
  const recaptchaRef = React.createRef();

  function sendEmail(e) {
    e.preventDefault();
    const recaptchaValue = recaptchaRef.current ? recaptchaRef.current.getValue() : "";

    // Extraemos los campos directamente por su atributo 'name'
    const formElements = e.target.elements;
    const name = formElements.Name?.value.trim() || "";
    const emailInput = formElements.Email?.value.trim() || "";
    const phone = formElements.Phone?.value.trim() || "";
    const about = formElements.Asunto?.value.trim() || "";
    const message = formElements.message?.value.trim() || "";

    const emailParams = {
      name,
      email: emailInput,
      phone,
      about,
      message,
      reply_to: emailInput,
    };

    // Validamos que el recaptcha y todos los campos requeridos estén completos
    if (
      recaptchaValue !== "" &&
      name.length > 0 &&
      emailInput.length > 0 &&
      phone.length > 0 &&
      about.length > 0 &&
      message.length > 0
    ) {
      emailjs
        .send('service_j9ql35v', 'template_iox6uig', emailParams, 'user_lv4rmCysUH0l11rwicUB5')
        .then(
          (result) => {
            console.log(result);
            setMensajeAlert(succes);
            e.target.reset(); // Limpia los campos del formulario
            if (recaptchaRef.current) recaptchaRef.current.reset(); // Reinicia el reCAPTCHA
            setTimeout(() => {
              setMensajeAlert("");
            }, 2000);
          },
          (error) => {
            console.log(error);
            setMensajeAlert(error2);
            setTimeout(() => {
              setMensajeAlert("");
            }, 2000);
          }
        );
    } else {
      setMensajeAlert(
        <div className="alert alert-warning" role="alert">
          ¡Verifique el ReCAPTCHA y los campos!
        </div>
      );
      setTimeout(() => {
        setMensajeAlert("");
      }, 2000);
    }
  }

  return (
    <div>
      <form className="p-4 form-home d-flex flex-column" id="formHome" onSubmit={sendEmail}>
        <input className="my-4 input" type="text" id="Name" placeholder="Nombre y apellido" name="Name" required />
        <input className="my-4 input" type="email" id="Email" placeholder="Email" name="Email" required />
        <input className="my-4 input" type="tel" id="Phone" placeholder="Teléfono" name="Phone" required />
        <input className="my-4 input" type="text" id="Asunto" placeholder="Asunto" name="Asunto" required />
        <textarea className="my-4 input" id="message" placeholder="Consulta" name="message" required />

        <ReCAPTCHA
          sitekey="6Lc1__EaAAAAAJxL3k8jskCk5Ft44A9edbAUbSnD"
          onChange={(e) => console.log(e)}
          ref={recaptchaRef}
        />

        <div className="d-flex justify-content-end">
          <input type="submit" value="> Enviar" className="btn btn-light btn-send mt-5 px-5" />
        </div>
      </form>
      {mensajeAlert}
    </div>
  );
}